"use client";
import { GoPersonFill } from "react-icons/go";
import { AvatarImage } from "~/components/shadcn/Avatar";
import { Avatar, AvatarFallback } from "../shadcn/Avatar";
import { cn } from "~/utils/fontsConfig";

const UserImage = ({
    user,
    iconSize,
    className,
}: {
    user: { image?: string | null };
    iconSize: number;
    className?: string;
}) => {
    if (!user) return null;
    return (
        <>
            <Avatar className={cn(className, "h-max w-max")}>
                <AvatarImage
                    src={user.image ?? undefined}
                    style={{
                        height: `${iconSize}px`,
                        width: `${iconSize}px`,
                    }}
                />
                <AvatarFallback className="h-full w-full bg-tertiary">
                    <GoPersonFill
                        className="text-primary"
                        aria-hidden="true"
                        style={{
                            height: `${iconSize}px`,
                            width: `${iconSize}px`,
                        }}
                        width={iconSize}
                        height={iconSize}
                    />
                </AvatarFallback>
            </Avatar>
        </>
    );
};

export default UserImage;
